"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CsvParserStream = void 0;

var string_decoder_1 = require("string_decoder");

var stream_1 = require("stream");

var transforms_1 = require("./transforms");

var parser_1 = require("./parser");

var CsvParserStream = /*#__PURE__*/function (_stream_1$Transform) {
  _inherits(CsvParserStream, _stream_1$Transform);

  var _super = _createSuper(CsvParserStream);

  function CsvParserStream(parserOptions) {
    var _this;

    _classCallCheck(this, CsvParserStream);

    _this = _super.call(this, {
      objectMode: parserOptions.objectMode
    });
    _this.lines = '';
    _this.rowCount = 0;
    _this.parsedRowCount = 0;
    _this.parsedLineCount = 0;
    _this.endEmitted = false;
    _this.headersEmitted = false;
    _this.parserOptions = parserOptions;
    _this.parser = new parser_1.Parser(parserOptions);
    _this.headerTransformer = new transforms_1.HeaderTransformer(parserOptions);
    _this.decoder = new string_decoder_1.StringDecoder(parserOptions.encoding);
    _this.rowTransformerValidator = new transforms_1.RowTransformerValidator();
    return _this;
  }

  _createClass(CsvParserStream, [{
    key: "hasHitRowLimit",
    get: function get() {
      return this.parserOptions.limitRows && this.rowCount >= this.parserOptions.maxRows;
    }
  }, {
    key: "shouldEmitRows",
    get: function get() {
      return this.parsedRowCount > this.parserOptions.skipRows;
    }
  }, {
    key: "shouldSkipLine",
    get: function get() {
      return this.parsedLineCount <= this.parserOptions.skipLines;
    }
  }, {
    key: "transform",
    value: function transform(transformFunction) {
      this.rowTransformerValidator.rowTransform = transformFunction;
      return this;
    }
  }, {
    key: "validate",
    value: function validate(validateFunction) {
      this.rowTransformerValidator.rowValidator = validateFunction;
      return this;
    } // eslint-disable-next-line @typescript-eslint/no-explicit-any

  }, {
    key: "emit",
    value: function emit(event) {
      var _get2;

      if (event === 'end') {
        if (!this.endEmitted) {
          this.endEmitted = true;

          _get(_getPrototypeOf(CsvParserStream.prototype), "emit", this).call(this, 'end', this.rowCount);
        }

        return false;
      }

      for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        rest[_key - 1] = arguments[_key];
      }

      return (_get2 = _get(_getPrototypeOf(CsvParserStream.prototype), "emit", this)).call.apply(_get2, [this, event].concat(rest));
    }
  }, {
    key: "_transform",
    value: function _transform(data, encoding, done) {
      // if we have hit our maxRows parsing limit then skip parsing
      if (this.hasHitRowLimit) {
        return done();
      }

      var wrappedCallback = CsvParserStream.wrapDoneCallback(done);

      try {
        var lines = this.lines;
        var newLine = lines + this.decoder.write(data);
        var rows = this.parse(newLine, true);
        return this.processRows(rows, wrappedCallback);
      } catch (e) {
        return wrappedCallback(e);
      }
    }
  }, {
    key: "_flush",
    value: function _flush(done) {
      var wrappedCallback = CsvParserStream.wrapDoneCallback(done); // if we have hit our maxRows parsing limit then skip parsing

      if (this.hasHitRowLimit) {
        return wrappedCallback();
      }

      try {
        var newLine = this.lines + this.decoder.end();
        var rows = this.parse(newLine, false);
        return this.processRows(rows, wrappedCallback);
      } catch (e) {
        return wrappedCallback(e);
      }
    }
  }, {
    key: "parse",
    value: function parse(data, hasMoreData) {
      if (!data) {
        return [];
      }

      var _this$parser$parse = this.parser.parse(data, hasMoreData),
          line = _this$parser$parse.line,
          rows = _this$parser$parse.rows;

      this.lines = line;
      return rows;
    }
  }, {
    key: "processRows",
    value: function processRows(rows, cb) {
      var _this2 = this;

      var rowsLength = rows.length;

      var iterate = function iterate(i) {
        var callNext = function callNext(err) {
          if (err) {
            return cb(err);
          }

          if (i % 100 === 0) {
            // incase the transform are sync insert a next tick to prevent stack overflow
            setImmediate(function () {
              return iterate(i + 1);
            });
            return undefined;
          }

          return iterate(i + 1);
        };

        _this2.checkAndEmitHeaders(); // if we have emitted all rows or we have hit the maxRows limit option
        // then end


        if (i >= rowsLength || _this2.hasHitRowLimit) {
          return cb();
        }

        _this2.parsedLineCount += 1;

        if (_this2.shouldSkipLine) {
          return callNext();
        }

        var row = rows[i];
        _this2.rowCount += 1;
        _this2.parsedRowCount += 1;
        var nextRowCount = _this2.rowCount;
        return _this2.transformRow(row, function (err, transformResult) {
          if (err) {
            _this2.rowCount -= 1;
            return callNext(err);
          }

          if (!transformResult) {
            return callNext(new Error('expected transform result'));
          }

          if (!transformResult.isValid) {
            _this2.emit('data-invalid', transformResult.row, nextRowCount, transformResult.reason);
          } else if (transformResult.row) {
            return _this2.pushRow(transformResult.row, callNext);
          }

          return callNext();
        });
      };

      iterate(0);
    }
  }, {
    key: "transformRow",
    value: function transformRow(parsedRow, cb) {
      var _this3 = this;

      try {
        this.headerTransformer.transform(parsedRow, function (err, withHeaders) {
          if (err) {
            return cb(err);
          }

          if (!withHeaders) {
            return cb(new Error('Expected result from header transform'));
          }

          if (!withHeaders.isValid) {
            if (_this3.shouldEmitRows) {
              return cb(null, {
                isValid: false,
                row: parsedRow
              });
            } // skipped because of skipRows option remove from total row count


            return _this3.skipRow(cb);
          }

          if (withHeaders.row) {
            if (_this3.shouldEmitRows) {
              return _this3.rowTransformerValidator.transformAndValidate(withHeaders.row, cb);
            } // skipped because of skipRows option remove from total row count


            return _this3.skipRow(cb);
          } // this is a header row dont include in the rowCount or parsedRowCount


          _this3.rowCount -= 1;
          _this3.parsedRowCount -= 1;
          return cb(null, {
            row: null,
            isValid: true
          });
        });
      } catch (e) {
        cb(e);
      }
    }
  }, {
    key: "checkAndEmitHeaders",
    value: function checkAndEmitHeaders() {
      if (!this.headersEmitted && this.headerTransformer.headers) {
        this.headersEmitted = true;
        this.emit('headers', this.headerTransformer.headers);
      }
    }
  }, {
    key: "skipRow",
    value: function skipRow(cb) {
      // skipped because of skipRows option remove from total row count
      this.rowCount -= 1;
      return cb(null, {
        row: null,
        isValid: true
      });
    }
  }, {
    key: "pushRow",
    value: function pushRow(row, cb) {
      try {
        if (!this.parserOptions.objectMode) {
          this.push(JSON.stringify(row));
        } else {
          this.push(row);
        }

        cb();
      } catch (e) {
        cb(e);
      }
    }
  }], [{
    key: "wrapDoneCallback",
    value: function wrapDoneCallback(done) {
      var errorCalled = false; // eslint-disable-next-line @typescript-eslint/no-explicit-any

      return function (err) {
        if (err) {
          if (errorCalled) {
            throw err;
          }

          errorCalled = true;
          done(err);
          return;
        }

        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }

        done.apply(void 0, args);
      };
    }
  }]);

  return CsvParserStream;
}(stream_1.Transform);

exports.CsvParserStream = CsvParserStream;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9Dc3ZQYXJzZXJTdHJlYW0udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsSUFBQSxnQkFBQSxHQUFBLE9BQUEsQ0FBQSxnQkFBQSxDQUFBOztBQUNBLElBQUEsUUFBQSxHQUFBLE9BQUEsQ0FBQSxRQUFBLENBQUE7O0FBRUEsSUFBQSxZQUFBLEdBQUEsT0FBQSxDQUFBLGNBQUEsQ0FBQTs7QUFDQSxJQUFBLFFBQUEsR0FBQSxPQUFBLENBQUEsVUFBQSxDQUFBOztJQUdhLGU7Ozs7O0FBdUJULDJCQUFtQixhQUFuQixFQUErQztBQUFBOztBQUFBOztBQUMzQyw4QkFBTTtBQUFFLE1BQUEsVUFBVSxFQUFFLGFBQWEsQ0FBQztBQUE1QixLQUFOO0FBYkksVUFBQSxLQUFBLEdBQVEsRUFBUjtBQUVBLFVBQUEsUUFBQSxHQUFXLENBQVg7QUFFQSxVQUFBLGNBQUEsR0FBaUIsQ0FBakI7QUFFQSxVQUFBLGVBQUEsR0FBa0IsQ0FBbEI7QUFFQSxVQUFBLFVBQUEsR0FBYSxLQUFiO0FBRUEsVUFBQSxjQUFBLEdBQWlCLEtBQWpCO0FBSUosVUFBSyxhQUFMLEdBQXFCLGFBQXJCO0FBQ0EsVUFBSyxNQUFMLEdBQWMsSUFBSSxRQUFBLENBQUEsTUFBSixDQUFXLGFBQVgsQ0FBZDtBQUNBLFVBQUssaUJBQUwsR0FBeUIsSUFBSSxZQUFBLENBQUEsaUJBQUosQ0FBc0IsYUFBdEIsQ0FBekI7QUFDQSxVQUFLLE9BQUwsR0FBZSxJQUFJLGdCQUFBLENBQUEsYUFBSixDQUFrQixhQUFhLENBQUMsUUFBaEMsQ0FBZjtBQUNBLFVBQUssdUJBQUwsR0FBK0IsSUFBSSxZQUFBLENBQUEsdUJBQUosRUFBL0I7QUFOMkM7QUFPOUM7Ozs7U0FFRCxlQUEwQjtBQUN0QixhQUFPLEtBQUssYUFBTCxDQUFtQixTQUFuQixJQUFnQyxLQUFLLFFBQUwsSUFBaUIsS0FBSyxhQUFMLENBQW1CLE9BQTNFO0FBQ0g7OztTQUVELGVBQTBCO0FBQ3RCLGFBQU8sS0FBSyxjQUFMLEdBQXNCLEtBQUssYUFBTCxDQUFtQixRQUFoRDtBQUNIOzs7U0FFRCxlQUEwQjtBQUN0QixhQUFPLEtBQUssZUFBTCxJQUF3QixLQUFLLGFBQUwsQ0FBbUIsU0FBbEQ7QUFDSDs7O1dBRU0sbUJBQVUsaUJBQVYsRUFBdUQ7QUFDMUQsV0FBSyx1QkFBTCxDQUE2QixZQUE3QixHQUE0QyxpQkFBNUM7QUFDQSxhQUFPLElBQVA7QUFDSDs7O1dBRU0sa0JBQVMsZ0JBQVQsRUFBeUM7QUFDNUMsV0FBSyx1QkFBTCxDQUE2QixZQUE3QixHQUE0QyxnQkFBNUM7QUFDQSxhQUFPLElBQVA7QUFDSCxLLENBRUQ7Ozs7V0FDTyxjQUFLLEtBQUwsRUFBMkM7QUFBQTs7QUFDOUMsVUFBSSxLQUFLLEtBQUssS0FBZCxFQUFxQjtBQUNqQixZQUFJLENBQUMsS0FBSyxVQUFWLEVBQXNCO0FBQ2xCLGVBQUssVUFBTCxHQUFrQixJQUFsQjs7QUFDQSxvRkFBVyxLQUFYLEVBQWtCLEtBQUssUUFBdkI7QUFDSDs7QUFDRCxlQUFPLEtBQVA7QUFDSDs7QUFQNkMsd0NBQVgsSUFBVztBQUFYLFFBQUEsSUFBVztBQUFBOztBQVE5QywrR0FBa0IsS0FBbEIsU0FBNEIsSUFBNUI7QUFDSDs7O1dBRU0sb0JBQVcsSUFBWCxFQUF5QixRQUF6QixFQUEyQyxJQUEzQyxFQUFrRTtBQUNyRTtBQUNBLFVBQUksS0FBSyxjQUFULEVBQXlCO0FBQ3JCLGVBQU8sSUFBSSxFQUFYO0FBQ0g7O0FBQ0QsVUFBTSxlQUFlLEdBQUcsZUFBZSxDQUFDLGdCQUFoQixDQUFpQyxJQUFqQyxDQUF4Qjs7QUFDQSxVQUFJO0FBQUEsWUFDUSxLQURSLEdBQ2tCLElBRGxCLENBQ1EsS0FEUjtBQUVBLFlBQU0sT0FBTyxHQUFHLEtBQUssR0FBRyxLQUFLLE9BQUwsQ0FBYSxLQUFiLENBQW1CLElBQW5CLENBQXhCO0FBQ0EsWUFBTSxJQUFJLEdBQUcsS0FBSyxLQUFMLENBQVcsT0FBWCxFQUFvQixJQUFwQixDQUFiO0FBQ0EsZUFBTyxLQUFLLFdBQUwsQ0FBaUIsSUFBakIsRUFBdUIsZUFBdkIsQ0FBUDtBQUNILE9BTEQsQ0FLRSxPQUFPLENBQVAsRUFBVTtBQUNSLGVBQU8sZUFBZSxDQUFDLENBQUQsQ0FBdEI7QUFDSDtBQUNKOzs7V0FFTSxnQkFBTyxJQUFQLEVBQThCO0FBQ2pDLFVBQU0sZUFBZSxHQUFHLGVBQWUsQ0FBQyxnQkFBaEIsQ0FBaUMsSUFBakMsQ0FBeEIsQ0FEaUMsQ0FFakM7O0FBQ0EsVUFBSSxLQUFLLGNBQVQsRUFBeUI7QUFDckIsZUFBTyxlQUFlLEVBQXRCO0FBQ0g7O0FBQ0QsVUFBSTtBQUNBLFlBQU0sT0FBTyxHQUFHLEtBQUssS0FBTCxHQUFhLEtBQUssT0FBTCxDQUFhLEdBQWIsRUFBN0I7QUFDQSxZQUFNLElBQUksR0FBRyxLQUFLLEtBQUwsQ0FBVyxPQUFYLEVBQW9CLEtBQXBCLENBQWI7QUFDQSxlQUFPLEtBQUssV0FBTCxDQUFpQixJQUFqQixFQUF1QixlQUF2QixDQUFQO0FBQ0gsT0FKRCxDQUlFLE9BQU8sQ0FBUCxFQUFVO0FBQ1IsZUFBTyxlQUFlLENBQUMsQ0FBRCxDQUF0QjtBQUNIO0FBQ0o7OztXQUVPLGVBQU0sSUFBTixFQUFvQixXQUFwQixFQUF3QztBQUM1QyxVQUFJLENBQUMsSUFBTCxFQUFXO0FBQ1AsZUFBTyxFQUFQO0FBQ0g7O0FBSDJDLCtCQUlyQixLQUFLLE1BQUwsQ0FBWSxLQUFaLENBQWtCLElBQWxCLEVBQXdCLFdBQXhCLENBSnFCO0FBQUEsVUFJcEMsSUFKb0Msc0JBSXBDLElBSm9DO0FBQUEsVUFJOUIsSUFKOEIsc0JBSTlCLElBSjhCOztBQUs1QyxXQUFLLEtBQUwsR0FBYSxJQUFiO0FBQ0EsYUFBTyxJQUFQO0FBQ0g7OztXQUVPLHFCQUFZLElBQVosRUFBOEIsRUFBOUIsRUFBbUQ7QUFBQTs7QUFDdkQsVUFBTSxVQUFVLEdBQUcsSUFBSSxDQUFDLE1BQXhCOztBQUNBLFVBQU0sT0FBTyxHQUFHLFNBQVYsT0FBVSxDQUFDLENBQUQsRUFBb0I7QUFDaEMsWUFBTSxRQUFRLEdBQUcsU0FBWCxRQUFXLENBQUMsR0FBRCxFQUFzQjtBQUNuQyxjQUFJLEdBQUosRUFBUztBQUNMLG1CQUFPLEVBQUUsQ0FBQyxHQUFELENBQVQ7QUFDSDs7QUFDRCxjQUFJLENBQUMsR0FBRyxHQUFKLEtBQVksQ0FBaEIsRUFBbUI7QUFDZjtBQUNBLFlBQUEsWUFBWSxDQUFDO0FBQUEscUJBQVksT0FBTyxDQUFDLENBQUMsR0FBRyxDQUFMLENBQW5CO0FBQUEsYUFBRCxDQUFaO0FBQ0EsbUJBQU8sU0FBUDtBQUNIOztBQUNELGlCQUFPLE9BQU8sQ0FBQyxDQUFDLEdBQUcsQ0FBTCxDQUFkO0FBQ0gsU0FWRDs7QUFXQSxRQUFBLE1BQUksQ0FBQyxtQkFBTCxHQVpnQyxDQWFoQztBQUNBOzs7QUFDQSxZQUFJLENBQUMsSUFBSSxVQUFMLElBQW1CLE1BQUksQ0FBQyxjQUE1QixFQUE0QztBQUN4QyxpQkFBTyxFQUFFLEVBQVQ7QUFDSDs7QUFDRCxRQUFBLE1BQUksQ0FBQyxlQUFMLElBQXdCLENBQXhCOztBQUNBLFlBQUksTUFBSSxDQUFDLGNBQVQsRUFBeUI7QUFDckIsaUJBQU8sUUFBUSxFQUFmO0FBQ0g7O0FBQ0QsWUFBTSxHQUFHLEdBQUcsSUFBSSxDQUFDLENBQUQsQ0FBaEI7QUFDQSxRQUFBLE1BQUksQ0FBQyxRQUFMLElBQWlCLENBQWpCO0FBQ0EsUUFBQSxNQUFJLENBQUMsY0FBTCxJQUF1QixDQUF2QjtBQUNBLFlBQU0sWUFBWSxHQUFHLE1BQUksQ0FBQyxRQUExQjtBQUNBLGVBQU8sTUFBSSxDQUFDLFlBQUwsQ0FBa0IsR0FBbEIsRUFBdUIsVUFBQyxHQUFELEVBQU0sZUFBTixFQUErQjtBQUN6RCxjQUFJLEdBQUosRUFBUztBQUNMLFlBQUEsTUFBSSxDQUFDLFFBQUwsSUFBaUIsQ0FBakI7QUFDQSxtQkFBTyxRQUFRLENBQUMsR0FBRCxDQUFmO0FBQ0g7O0FBQ0QsY0FBSSxDQUFDLGVBQUwsRUFBc0I7QUFDbEIsbUJBQU8sUUFBUSxDQUFDLElBQUksS0FBSixDQUFVLDJCQUFWLENBQUQsQ0FBZjtBQUNIOztBQUNELGNBQUksQ0FBQyxlQUFlLENBQUMsT0FBckIsRUFBOEI7QUFDMUIsWUFBQSxNQUFJLENBQUMsSUFBTCxDQUFVLGNBQVYsRUFBMEIsZUFBZSxDQUFDLEdBQTFDLEVBQStDLFlBQS9DLEVBQTZELGVBQWUsQ0FBQyxNQUE3RTtBQUNILFdBRkQsTUFFTyxJQUFJLGVBQWUsQ0FBQyxHQUFwQixFQUF5QjtBQUM1QixtQkFBTyxNQUFJLENBQUMsT0FBTCxDQUFhLGVBQWUsQ0FBQyxHQUE3QixFQUFrQyxRQUFsQyxDQUFQO0FBQ0g7O0FBQ0QsaUJBQU8sUUFBUSxFQUFmO0FBQ0gsU0FkTSxDQUFQO0FBZUgsT0F6Q0Q7O0FBMENBLE1BQUEsT0FBTyxDQUFDLENBQUQsQ0FBUDtBQUNIOzs7V0FFTyxzQkFBYSxTQUFiLEVBQWtDLEVBQWxDLEVBQTZEO0FBQUE7O0FBQ2pFLFVBQUk7QUFDQSxhQUFLLGlCQUFMLENBQXVCLFNBQXZCLENBQWlDLFNBQWpDLEVBQTRDLFVBQUMsR0FBRCxFQUFNLFdBQU4sRUFBMkI7QUFDbkUsY0FBSSxHQUFKLEVBQVM7QUFDTCxtQkFBTyxFQUFFLENBQUMsR0FBRCxDQUFUO0FBQ0g7O0FBQ0QsY0FBSSxDQUFDLFdBQUwsRUFBa0I7QUFDZCxtQkFBTyxFQUFFLENBQUMsSUFBSSxLQUFKLENBQVUsdUNBQVYsQ0FBRCxDQUFUO0FBQ0g7O0FBQ0QsY0FBSSxDQUFDLFdBQVcsQ0FBQyxPQUFqQixFQUEwQjtBQUN0QixnQkFBSSxNQUFJLENBQUMsY0FBVCxFQUF5QjtBQUNyQixxQkFBTyxFQUFFLENBQUMsSUFBRCxFQUFPO0FBQUUsZ0JBQUEsT0FBTyxFQUFFLEtBQVg7QUFBa0IsZ0JBQUEsR0FBRyxFQUFHO0FBQXhCLGVBQVAsQ0FBVDtBQUNILGFBSHFCLENBSXRCOzs7QUFDQSxtQkFBTyxNQUFJLENBQUMsT0FBTCxDQUFhLEVBQWIsQ0FBUDtBQUNIOztBQUNELGNBQUksV0FBVyxDQUFDLEdBQWhCLEVBQXFCO0FBQ2pCLGdCQUFJLE1BQUksQ0FBQyxjQUFULEVBQXlCO0FBQ3JCLHFCQUFPLE1BQUksQ0FBQyx1QkFBTCxDQUE2QixvQkFBN0IsQ0FBa0QsV0FBVyxDQUFDLEdBQTlELEVBQW1FLEVBQW5FLENBQVA7QUFDSCxhQUhnQixDQUlqQjs7O0FBQ0EsbUJBQU8sTUFBSSxDQUFDLE9BQUwsQ0FBYSxFQUFiLENBQVA7QUFDSCxXQXBCa0UsQ0FxQm5FOzs7QUFDQSxVQUFBLE1BQUksQ0FBQyxRQUFMLElBQWlCLENBQWpCO0FBQ0EsVUFBQSxNQUFJLENBQUMsY0FBTCxJQUF1QixDQUF2QjtBQUNBLGlCQUFPLEVBQUUsQ0FBQyxJQUFELEVBQU87QUFBRSxZQUFBLEdBQUcsRUFBRSxJQUFQO0FBQWEsWUFBQSxPQUFPLEVBQUU7QUFBdEIsV0FBUCxDQUFUO0FBQ0gsU0F6QkQ7QUEwQkgsT0EzQkQsQ0EyQkUsT0FBTyxDQUFQLEVBQVU7QUFDUixRQUFBLEVBQUUsQ0FBQyxDQUFELENBQUY7QUFDSDtBQUNKOzs7V0FFTywrQkFBbUI7QUFDdkIsVUFBSSxDQUFDLEtBQUssY0FBTixJQUF3QixLQUFLLGlCQUFMLENBQXVCLE9BQW5ELEVBQTREO0FBQ3hELGFBQUssY0FBTCxHQUFzQixJQUF0QjtBQUNBLGFBQUssSUFBTCxDQUFVLFNBQVYsRUFBcUIsS0FBSyxpQkFBTCxDQUF1QixPQUE1QztBQUNIO0FBQ0o7OztXQUVPLGlCQUFRLEVBQVIsRUFBbUM7QUFDdkM7QUFDQSxXQUFLLFFBQUwsSUFBaUIsQ0FBakI7QUFDQSxhQUFPLEVBQUUsQ0FBQyxJQUFELEVBQU87QUFBRSxRQUFBLEdBQUcsRUFBRSxJQUFQO0FBQWEsUUFBQSxPQUFPLEVBQUU7QUFBdEIsT0FBUCxDQUFUO0FBQ0g7OztXQUVPLGlCQUFRLEdBQVIsRUFBa0IsRUFBbEIsRUFBMkM7QUFDL0MsVUFBSTtBQUNBLFlBQUksQ0FBQyxLQUFLLGFBQUwsQ0FBbUIsVUFBeEIsRUFBb0M7QUFDaEMsZUFBSyxJQUFMLENBQVUsSUFBSSxDQUFDLFNBQUwsQ0FBZSxHQUFmLENBQVY7QUFDSCxTQUZELE1BRU87QUFDSCxlQUFLLElBQUwsQ0FBVSxHQUFWO0FBQ0g7O0FBQ0QsUUFBQSxFQUFFO0FBQ0wsT0FQRCxDQU9FLE9BQU8sQ0FBUCxFQUFVO0FBQ1IsUUFBQSxFQUFFLENBQUMsQ0FBRCxDQUFGO0FBQ0g7QUFDSjs7O1dBRU8sMEJBQXdCLElBQXhCLEVBQStDO0FBQ25ELFVBQUksV0FBVyxHQUFHLEtBQWxCLENBRG1ELENBRW5EOztBQUNBLGFBQU8sVUFBQyxHQUFELEVBQXdEO0FBQzNELFlBQUksR0FBSixFQUFTO0FBQ0wsY0FBSSxXQUFKLEVBQWlCO0FBQ2Isa0JBQU0sR0FBTjtBQUNIOztBQUNELFVBQUEsV0FBVyxHQUFHLElBQWQ7QUFDQSxVQUFBLElBQUksQ0FBQyxHQUFELENBQUo7QUFDQTtBQUNIOztBQVIwRCwyQ0FBckIsSUFBcUI7QUFBckIsVUFBQSxJQUFxQjtBQUFBOztBQVMzRCxRQUFBLElBQUksTUFBSixTQUFRLElBQVI7QUFDSCxPQVZEO0FBV0g7Ozs7RUFsTzhELFFBQUEsQ0FBQSxTOztBQUFuRSxPQUFBLENBQUEsZUFBQSxHQUFBLGVBQUEiLCJzb3VyY2VSb290IjoiIn0=